import TBodyRow from './TBodyRow';

interface IProps {
  moduleData: any;
  handleDelete: any;
  isView: boolean;
  setPartIdx: React.Dispatch<React.SetStateAction<number>>;
  setIsOpenPopup: React.Dispatch<React.SetStateAction<boolean>>;
  defects: any;
  processes: any;
}

const TBody = ({
  moduleData,
  isView,
  handleDelete,
  setPartIdx,
  setIsOpenPopup,
  defects,
  processes,
}: IProps) => {
  return (
    <tbody>
      {moduleData?.map((item: any, index: number) => (
        <TBodyRow
          {...{
            item,
            index,
            isView,
            handleDelete,
            setPartIdx,
            setIsOpenPopup,
            defects,
            processes,
          }}
        />
      ))}
    </tbody>
  );
};

export default TBody;
